export const createUrlInvoice = (accessKey: string) => {
  const baseLink = 'https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=resumo&tipoConteudo=7PhJ+gAVw2g='

  const params = '&nfe=' + accessKey

  return baseLink + params
}
